/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const convertAssetToFeature = (asset) => {
    const feature = {
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [asset.longitude, asset.latitude],
        },
        properties: {
            name: asset.name,
            featureId: asset.featureId,
            icon: asset.mapIcon,
            location: asset.location,
        },
    };

    return feature;
};

const convertSearchResultToGeoJson = (searchResultList = []) => {
    const geoJSON = {
        type: 'FeatureCollection',
        features: [],
    };

    let asset;
    searchResultList.forEach((location) => {
        asset = null;

        if (location.lat_long && location.lat_long.long && location.lat_long.lat) {
            asset = { attributes: [] };
            asset.name = location.name;
            asset.title = location.name;
            asset.longitude = location.lat_long.long;
            asset.latitude = location.lat_long.lat;
            asset.featureId = location.id;

            if (location.city && location.state) {
                asset.location = `${location.city}, ${location.state}`;
            } else if (location.city) {
                asset.location = location.city;
            } else if (location.state) {
                asset.location = location.state;
            }

            const feature = convertAssetToFeature(asset);
            geoJSON.features.push(feature);
        }
    });

    return geoJSON;
};

export { convertSearchResultToGeoJson, convertAssetToFeature };
